module.exports = __webpack_public_path__ + "img/9.6b8ed6c2.jpg";